<ng-container *ngIf="graphData">
	<div
		class="card mt-4"
		*ngFor="let eachUnitGraph of graphData.progressDataSchool; let i = index"
	>
		<div class="card-header" data-html2canvas-ignore>
			{{ eachUnitGraph.graphTitle }}
		</div>
		<app-component-loader [loading]="LoaderService.loadingProgressBarSchool"></app-component-loader>
		<app-eachbar id="app-eachbar" [data]="eachUnitGraph"></app-eachbar>
	</div>
</ng-container>
<br/><br/><br/><br/><br/>

